import { retainedState } from 'shared/src/hooks/retainedState';

/**
 * 섹션별 측정 높이({ sectionKey: height }). visit 단위로 보관한다.
 *
 * depth 2+ 진입으로 content 가 unmount→remount 되면 평범한 useRef 는 비어서, 각 섹션이
 * 0 에서 시작해 측정될 때까지 자란다. 그동안 리스트 contentSize 가 짧아 스크롤 복원이
 * target 에 닿지 못하고, useScrollRestoration 은 콘텐츠가 자라도록 바닥까지 밀며 기다린다
 * (실측: restoring 3.0s — 2s backstop + JS 스레드 지연).
 *
 * 같은 visit 안에서는 재측정값이 보관값과 동일하다(실측: remount 시 11개 섹션 전부 일치).
 * 그래서 보관값을 minHeight 로 예약해 첫 프레임부터 제 높이를 차지하게 한다.
 *
 * `height` 가 아니라 `minHeight` 인 이유: 실제 콘텐츠가 더 커질 수 있다(웹뷰 로드, 상품정보
 * 펼치기). 고정하면 잘리므로, 예약만 하고 넘치면 자라도록 둔다.
 *
 * (초기값은 함수형 — visit 마다 새 객체를 받아야 이전 visit 의 맵을 물려받지 않는다.)
 */
export const sectionHeightSlot = retainedState<Record<string, number>>(
  () => ({}),
);
